// Resizes an image file down to a max dimension that keeps document text
// readable while cutting upload size, using an off-screen canvas. Non-image
// files (e.g. PDFs) are returned unchanged.
const MAX_DIMENSION = 2000;
const JPEG_QUALITY = 0.85;
// Some mobile browsers never fire onload/onerror for unsupported formats
// (e.g. HEIC) or hang decoding very large camera photos onto a canvas — this
// bounds the wait so an upload can never be stuck "resizing" forever.
const RESIZE_TIMEOUT_MS = 8000;

function resizeImageFileInner(file, maxDimension, quality) {
  return new Promise(resolve => {
    const img = new Image();
    const objectUrl = URL.createObjectURL(file);

    img.onload = () => {
      URL.revokeObjectURL(objectUrl);

      try {
        const { width, height } = img;
        const scale = Math.min(1, maxDimension / Math.max(width, height));
        if (scale >= 1) {
          resolve(file);
          return;
        }

        const canvas = document.createElement("canvas");
        canvas.width = Math.round(width * scale);
        canvas.height = Math.round(height * scale);
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        canvas.toBlob(
          blob => {
            if (!blob) {
              resolve(file);
              return;
            }
            const name = file.name.replace(/\.[^.]+$/, "") + ".jpg";
            resolve(new File([blob], name, { type: "image/jpeg" }));
          },
          "image/jpeg",
          quality
        );
      } catch (e) {
        resolve(file);
      }
    };

    img.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      resolve(file);
    };

    img.src = objectUrl;
  });
}

export function resizeImageFile(file, maxDimension = MAX_DIMENSION, quality = JPEG_QUALITY) {
  if (!file || !file.type || !file.type.startsWith("image/")) {
    return Promise.resolve(file);
  }

  const timeout = new Promise(resolve => {
    setTimeout(() => resolve(file), RESIZE_TIMEOUT_MS);
  });

  return Promise.race([resizeImageFileInner(file, maxDimension, quality), timeout]);
}
